// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3f4a0c6a","455":"625a77ec","977":"21b09cc0"}[chunkId] + ".chunk.js";
};